import React from 'react';

const KanbanContext = React.createContext();

export default KanbanContext;